import auth from "../../../../Auth";
import { faSave } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimesCircle } from "@fortawesome/free-solid-svg-icons";
import * as React from "react";
import { successToastr } from "../../../../../HelperMethods";
import { ErrorComponent } from "../../../../ReusableComponents";
import { filterBy } from "@progress/kendo-data-query";
import Skeleton from "react-loading-skeleton";
import globalAdminService from "../../Service/DataService";
import { DONOTHIRE_MSG, REMOVEDONOTHIRE_MSG, REMOVE_DNR_CONFIRMATION_MSG } from "../../../../Shared/AppMessages";
import { IDropDownModel } from "../../../../Shared/Models/IDropDownModel";
import { DropDownList, MultiSelect } from "@progress/kendo-react-dropdowns";
import withValueField from "../../../../Shared/withValueField";
import lookup from "../../../../Lookup/Services";
import ConfirmationModal from "../../../../Shared/ConfirmationModal";

export interface DoNotHireProps {
    props: any;
    match?: any;
    location?: any;
    onCloseModal: any;
    onOpenModal: any;
}

export interface DoNotHireState {
    candidateId: string;
    clientName: string;
    clientIds: any[];
    reasonId: string
    reasons: Array<IDropDownModel>;
    clients: Array<IDropDownModel>;
    showLoader?: boolean;
    submitted: boolean;
    showRemoveModal: boolean;

}
const CustomDropDownList = withValueField(DropDownList);

const defaultItem = { reason: "Select reason..", id: null };

class DoNotHire extends React.Component<DoNotHireProps, DoNotHireState> {
    private userClients: any = []
    constructor(props: DoNotHireProps) {
        super(props);
        this.state = {
            candidateId: "",
            clientName: auth.getClientName(),
            reasonId: "",
            clientIds: [],
            clients: [],
            reasons: [],
            showLoader: false,
            submitted: false,
            showRemoveModal: false

        };
        this.handleFilterChange = this.handleFilterChange.bind(this);
    }

    componentDidMount() {
        this.userClients = JSON.parse(localStorage.getItem("UserClientLob"));
        var selectedClient = [];

        this.getReasons();
        if (this.props.props.dnhClientIds) {
            this.props.props.dnhClientIds.forEach((item) => {
                var id = this.userClients.find(x => x.id == item);
                selectedClient.push(id);
            })
            this.setState({ clientIds: selectedClient, reasonId: this.props.props.dnhReasonId })
        }
    }

    getReasons = () => {
        lookup.getDoNotHireReasons()
            .then(async res => {
                this.setState({ reasons: res.data, showLoader: false });
            });
    }

    filterData(filter, originalArray) {
        const data1 = this.state[originalArray];
        return filterBy(data1, filter);
    }

    openNew = () => {
        this.props.onOpenModal();
    };

    handleProviderChange = (e) => {
        this.setState({ clientIds: e.value });
    }
    handleFilterChange(event) {
        var name = event.target.props.id;
        var originalArray = "original" + name;
        this.state[name] = this.filterData(event.filter, originalArray);
        this.setState(this.state);
    }



    handleSave = () => {
        this.setState({ submitted: true })
        if (!this.state.clientIds || this.state.clientIds.length == 0 || this.state.reasonId == "") return;
        let data = {
            clientIds: this.state.clientIds.map(object => object.id),
            reasonId: this.state.reasonId,
        };

        globalAdminService.doNotHireCand(this.props.props.id, data).then((res) => {
            successToastr(DONOTHIRE_MSG);
            this.props.onCloseModal();
        });

    }
    handleAvailable = () => {
        globalAdminService.removeDNR(this.props.props.id).then((res) => {
            successToastr(REMOVEDONOTHIRE_MSG);
            this.props.onCloseModal();
        });

    }

    handleReasonChange = (e) => {
        const id = e.value.id;
        if (id) {
            this.setState({ reasonId: id });
        }
        else {
            this.setState({ reasonId: null });
        }
    }


    render() {
        return (
            <div className="row mt-0 ml-0 mr-0 mt-lg-0 align-items-center mb-0 d-flex justify-content-end holdposition-width">
                <div className="modal-content border-0">
                    <div className="modal-header rounded-0 bg-blue d-flex justify-content-center align-items-center pt-2 pb-2">
                        <h4 className="modal-title text-white fontFifteen">
                            {this.props.props.dnhClientIds ? "Edit Do Not Rehire" : "Do Not Rehire"}
                        </h4>
                        <button type="button" className="close text-white close_opacity" data-dismiss="modal" onClick={this.props.onCloseModal}>
                            &times;
                        </button>
                    </div>
                    {this.state.showLoader &&
                        Array.from({ length: 2 }).map((item, i) => (
                            <div className="row mx-auto mt-2" key={i}>
                                {Array.from({ length: 3 }).map((item, j) => (
                                    <div className="col-12 col-sm-4 col-lg-4 mt-sm-0  mt-1" key={j}>
                                        <Skeleton width={230} />
                                        <Skeleton height={30} />
                                    </div>
                                ))}
                            </div>
                        ))}
                    {!this.state.showLoader && (
                        <div>
                            <div className="row mt-3 mx-0">
                                <div className="col-6 col-sm-6 col-md-6 col-lg-6 mt-1 mt-sm-0">
                                    <label className="mb-0 font-weight-bold required">Reason</label>
                                    <CustomDropDownList
                                        className="form-control mt-1"
                                        data={this.state.reasons}
                                        textField="reason"
                                        valueField="id"
                                        id="reasons"
                                        name="id"
                                        value={this.state.reasonId}
                                        defaultItem={defaultItem}
                                        onChange={(e) => this.handleReasonChange(e)}
                                    />
                                    {this.state.submitted && (!this.state.reasonId) && <ErrorComponent />}
                                </div>
                                <div className="col-6 col-sm-6 col-md-6 col-lg-6 mt-1 mt-sm-0">
                                    <label className="mb-0 font-weight-bold required">Clients</label>
                                    <MultiSelect
                                        className="form-control disabled"
                                        data={this.userClients}
                                        textField="name"
                                        dataItemKey="id"
                                        id="userClients"
                                        value={this.state.clientIds}
                                        placeholder="Select clients..."
                                        filterable={true}
                                        onFilterChange={this.handleFilterChange}
                                        onChange={(e) => this.handleProviderChange(e)}

                                    />
                                    {this.state.submitted && (!this.state.clientIds || this.state.clientIds.length == 0) && <ErrorComponent />}

                                </div>
                            </div>
                        </div>
                    )}

                    <ConfirmationModal
                        message={REMOVE_DNR_CONFIRMATION_MSG()}
                        showModal={this.state.showRemoveModal}
                        handleYes={() => this.handleAvailable()}
                        handleNo={() => {
                            this.setState({ showRemoveModal: false });
                        }}
                    />
                    <div className="modal-footer justify-content-center border-0 mt-3 mb-3">
                        <div className="row mt-2 mb-2 ml-0 mr-0 justify-content-center">
                            <button type="button" className="btn button button-close mr-2 shadow mb-2 mb-xl-0" onClick={this.props.onCloseModal}>
                                <FontAwesomeIcon icon={faTimesCircle} className={"mr-1"} /> Close
                            </button>
                            <button type="button" className="btn button button-bg mr-2 shadow mb-2 mb-xl-0" onClick={this.handleSave}>
                                <FontAwesomeIcon icon={faSave} className={"mr-1"} /> Save
                            </button>
                            {this.props.props.dnhClientIds && (
                                <button type="button" className="btn button button-bg mr-2 shadow mb-2 mb-xl-0" onClick={() => { this.setState({ showRemoveModal: true }) }}>
                                    <FontAwesomeIcon icon={faSave} className={"mr-1"} /> Remove DNR
                                </button>
                            )}
                        </div>

                    </div>
                </div>
            </div >
        );
    }
}
export default DoNotHire;